var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStatusAbandoned = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19zm.978 3H8.12c-.893 0-1.62.73-1.62 1.625v9.75c0 .896.727 1.625 1.62 1.625h4.858a.54.54 0 0 0 .54-.542.54.54 0 0 0-.54-.541H8.12a.541.541 0 0 1-.54-.542v-9.75c0-.299.242-.542.54-.542h4.858a.54.54 0 0 0 .54-.541.54.54 0 0 0-.54-.542zm3.079 2.864a.538.538 0 0 0-.764.006.542.542 0 0 0 .006.766l2.345 2.322H11.36a.54.54 0 0 0-.54.542c0 .3.241.542.54.542h6.285L15.3 14.864a.543.543 0 0 0 .379.928.536.536 0 0 0 .379-.156l3.282-3.25a.544.544 0 0 0 0-.772z",
    fill: "#02607F"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStatusAbandoned);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-status-abandoned.203ccaef3f744e91ca1dcb2a398633b9.svg";